import Base from 'app/views/base';

import tmpl from 'templates/api_mode_toggle';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click input[type="radio"]': 'switchMode',
  },

  context() {
    return {
      mode: this.model.get('mode'),
    };
  },

  switchMode(e) {
    if (this.model.get('mode') !== $(e.target).val()) {
      this.model.toggle();
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/api_mode_toggle.js